import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api, { errMsg } from "@/lib/api";
import { ZInput } from "@/components/ZInput";
import ZButton from "@/components/ZButton";
import Logo from "@/components/Logo";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (p1.length < 6) return setErr("Mot de passe : 6 caractères minimum.");
    if (p1 !== p2) return setErr("Les mots de passe ne correspondent pas.");
    setLoading(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: p1 });
      setDone(true);
      toast.success("Mot de passe mis à jour.");
      setTimeout(() => nav("/login"), 2000);
    } catch (e) {
      setErr(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="z-container" style={{ maxWidth: 460 }} data-testid="reset-password-page">
      <div style={{ textAlign: "center", marginBottom: 28 }}>
        <Logo to={null} size={28} />
      </div>

      {done ? (
        <div className="z-card" style={{ padding: 28, textAlign: "center" }} data-testid="reset-password-done">
          <div style={{ color: "var(--z-teal)", display: "flex", justifyContent: "center", marginBottom: 12 }}>
            <CheckCircle2 size={40} />
          </div>
          <h1 className="z-page-title" style={{ fontSize: 22 }}>Mot de passe modifié</h1>
          <p className="z-page-sub">Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.</p>
          <Link to="/login" className="z-btn" data-testid="reset-to-login">Se connecter</Link>
        </div>
      ) : (
        <>
          <h1 className="z-page-title">Nouveau mot de passe</h1>
          <p className="z-page-sub">Choisissez un mot de passe sécurisé (6 caractères minimum).</p>
          <form onSubmit={submit} className="z-card" style={{ padding: 24 }}>
            <ZInput
              type="password" label="Nouveau mot de passe" value={p1}
              onChange={(e) => setP1(e.target.value)} required minLength={6}
              autoComplete="new-password"
              data-testid="reset-password-new"
            />
            <ZInput
              type="password" label="Confirmer" value={p2}
              onChange={(e) => setP2(e.target.value)} required minLength={6}
              autoComplete="new-password"
              data-testid="reset-password-confirm"
            />
            {err && <p className="z-error-text" data-testid="reset-password-error">{err}</p>}
            <ZButton type="submit" block loading={loading} data-testid="reset-password-submit">
              Réinitialiser
            </ZButton>
            <div style={{ textAlign: "center", marginTop: 16, fontSize: 14, color: "var(--z-muted)" }}>
              <Link to="/login" className="z-link" data-testid="reset-to-login-link">Retour à la connexion</Link>
            </div>
          </form>
        </>
      )}
    </div>
  );
}
